import _objectWithoutProperties from "/home/bamboo/bamboo-agent-home/xml-data/build-dir/DETOX-SHOP218-JOB1/node_modules/gatsby/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["title", "titleId"];

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

import * as React from "react";

function Show(_ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 16,
    height: props.size || 16,
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M12.118 3c6.31 0 9.65 5.175 10.792 7.401a2.97 2.97 0 010 2.707c-1.142 2.226-4.482 7.402-10.792 7.402S2.47 15.334 1.326 13.108a2.97 2.97 0 010-2.707C2.47 8.175 5.81 3 12.118 3zm0 2c-5.207 0-8.037 4.416-9.012 6.315a.961.961 0 000 .878c.975 1.9 3.804 6.317 9.012 6.317s8.038-4.417 9.013-6.316a.962.962 0 000-.88C20.156 9.416 17.325 5 12.118 5zm0 2.057a4.702 4.702 0 014.697 4.697 4.703 4.703 0 01-4.697 4.698 4.703 4.703 0 01-4.697-4.698 4.702 4.702 0 014.697-4.697zm0 2a2.7 2.7 0 00-2.697 2.697 2.7 2.7 0 002.697 2.698 2.7 2.7 0 002.697-2.698 2.7 2.7 0 00-2.697-2.697z",
    fill: props.color || "#222",
    fillRule: "evenodd"
  }));
}

var MemoShow = React.memo(Show);
export default MemoShow;